import { XCircle } from 'lucide-react';

import { AddressBlock } from './address-blocks';
import type { EnteredAddressSnapshot } from './address-blocks';

export function FixContent({ enteredAddress }: { enteredAddress: EnteredAddressSnapshot | null }) {
  if (!enteredAddress) return null;

  return (
    <section className="border-c-border rounded-xl border p-4">
      <div className="mb-2 flex items-center gap-2">
        <XCircle className="text-error h-4 w-4" />
        <h6 className="text-base font-semibold">Address Entered</h6>
      </div>
      <AddressBlock
        line1={enteredAddress.address1}
        line2={enteredAddress.address2}
        cityStateZip={[enteredAddress.city, enteredAddress.state, enteredAddress.postalCode].filter(Boolean).join(', ')}
        country={enteredAddress.country}
      />
    </section>
  );
}
